import { render, staticRenderFns } from "./MissingExtracts.vue?vue&type=template&id=364a865c&scoped=true"
import script from "./MissingExtracts.vue?vue&type=script&lang=js"
export * from "./MissingExtracts.vue?vue&type=script&lang=js"
import style0 from "./MissingExtracts.vue?vue&type=style&index=0&id=364a865c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364a865c",
  null
  
)

export default component.exports